function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m242.6875 384.824219c-5.9375-44.035157 16.054688-87.136719 55.191406-108.175781 39.140625-21.035157 87.21875-15.601563 120.675782 13.644531 33.453124 29.242187 45.265624 76.164062 29.648437 117.765625-15.617187 41.597656-55.390625 69.152344-99.824219 69.15625-53.460937.191406-98.734375-39.382813-105.691406-92.390625zm0 0",
  fill: "#00efd1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m201.386719 254.714844h38.902343c19.546876 0 37.410157 11.066406 46.109376 28.570312l.238281.339844c-32.300781 22.957031-49.222657 61.925781-43.949219 101.199219h-242.578125v-78.648438c0-28.421875 23.039063-51.460937 51.457031-51.460937h38.671875c31.410157 27.179687 77.871094 27.644531 109.820313 1.101562zm0 0",
  fill: "#00acea"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m103.886719 12.105469c6.007812-9.625 17.609375-14.175781 28.5625-11.210938l28.929687 7.820313c11.632813 3.140625 23.796875 3.800781 35.699219 1.929687l63.191406-9.9375c0 21.539063-8.472656 44.167969-26.671875 53.546875-1.992187 1.03125-4.070312 1.882813-6.210937 2.550782 0 0-62.519531 9.609374-102.597657 11.949218-5.550781.320313-10.660156.5-15.121093.5-2.566407.003906-5.027344-1.015625-6.839844-2.828125s-2.832031-4.273437-2.828125-6.839843v-33.851563c-.015625-4.816406 1.332031-9.542969 3.886719-13.628906zm0 0",
  fill: "#4b5d63"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m201.386719 218.136719c-31.957031 27.242187-78.972657 27.238281-110.929688-.011719-20.421875-17.132812-32.242187-42.402344-32.308593-69.058594v-52.851562h.28125c9.957031 1.589844 37.199218 4.269531 66.367187-27.300782l-.007813-.160156c40.078126-2.339844 102.597657-11.949218 102.597657-11.949218 2.140625-.667969 4.21875-1.519532 6.210937-2.550782l.109375.203125v94.609375c-.046875 23.523438-9.273437 46.101563-25.707031 62.929688-2.101562 2.15625-4.304688 4.207031-6.613281 6.140625zm0 0",
  fill: "#f7caa5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m201.386719 218.136719v36.578125l-1.328125 1.101562c-31.949219 26.542969-78.410156 26.078125-109.820313-1.101562v-36.320313l.21875-.269531c31.957031 27.25 78.972657 27.253906 110.929688.011719zm0 0",
  fill: "#edb288"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m124.789062 68.753906.007813.160156c-29.167969 31.570313-56.410156 28.890626-66.367187 27.300782h-.28125v-7.070313c.011718-32.109375 17.550781-61.65625 45.738281-77.039062-2.554688 4.085937-3.902344 8.8125-3.886719 13.628906v33.851563c-.003906 2.566406 1.015625 5.027343 2.828125 6.839843s4.273437 2.832031 6.839844 2.828125c4.460937 0 9.570312-.179687 15.121093-.5zm0 0",
  fill: "#3c555b"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m387.839844 384.984375h-44.921875c-3.3125 0-6-2.683594-6-6v-58.777344c0-3.316406 2.6875-6 6-6s6 2.683594 6 6v52.777344h38.921875c3.3125 0 6 2.6875 6 6 0 3.316406-2.6875 6-6 6zm0 0",
  fill: "#00acea"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "477pt",
    viewBox: "-11 0 477 477.21652",
    width: "477pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b11d1897.svg";
export { ForwardRef as ReactComponent };